import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DirectionState {
  selectedDirection: string;
}

const initialState: DirectionState = {
  selectedDirection: "left",
};

export const directionSlice = createSlice({
  name: "direction",
  initialState,
  reducers: {
    setSelectedDirection: (state, action: PayloadAction<string>) => {
      state.selectedDirection = action.payload;
    },
  },
});

export const { setSelectedDirection } = directionSlice.actions;
export const direction = directionSlice.reducer;
